<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" :color="snackBarColor" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <v-dialog v-model="cancelDialog" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12 pb-4>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
            >
              Do you want to cancel this deal ?
            </span>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="cancelDeal"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="cancelDialog = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog> -->
    <v-container class="px-2 px-sm-4 py-6">
      <!-- Back Button & Header -->
      <v-row align="start" class="mb-6">
        <v-col cols="12">
          <div class="d-flex align-start align-sm-center">
            <v-btn icon @click="$router.go(-1)" class="mr-2 mt-n1 mt-sm-0">
              <v-icon color="#1c1c1c">mdi-arrow-left</v-icon>
            </v-btn>
            <div class="d-flex flex-column flex-sm-row align-start align-sm-center flex-grow-1">
              <h1 class="page-title mr-sm-4">Order Details</h1>
              <v-spacer class="hidden-xs-only"></v-spacer>
              <v-chip
                v-if="order.orderID"
                color="#3EA56E"
                label
                outlined
                class="id-chip px-4 mt-2 mt-sm-0"
              >
                Order #{{ order.orderID }}
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Order Summary Banner -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card flat class="summary-banner pa-6">
            <v-row align="center">
              <v-col cols="12" sm="8">
                <div class="d-flex flex-column">
                  <span class="banner-label">Placed On</span>
                  <span class="banner-value">{{ formatDate(order.init_date) }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="text-sm-right">
                <div class="d-flex flex-column align-sm-end">
                  <span class="banner-label">Payment Status</span>
                  <v-chip color="#3EA56E" dark small label class="mt-1 font-weight-bold">
                    PAID
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <!-- Items List -->
        <v-col cols="12" md="8">
          <h2 class="section-title mb-4">Items in this order</h2>
          <div v-for="(item, i) in product" :key="i" class="mb-4">
            <v-card flat class="order-item-card">
              <OrderItem
                :storage="item"
                :order="order"
                @stepper="winStepper"
              />
            </v-card>
          </div>
        </v-col>

        <!-- Order Sidebar (Summary & Address) -->
        <v-col cols="12" md="4">
          <h2 class="section-title mb-4">Summary</h2>
          <v-card flat class="sidebar-card pa-4">
            <OrderDetails :storage="order" :items="product" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import OrderItem from "./orderItem";
import OrderDetails from "./orderDetails";
export default {
  props: ["id"],
  components: {
    OrderItem,
    OrderDetails,
  },
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      snackBarColor: "",
      ServerError: false,
      showSnackBar: false,
      orders: [],
      product: [],
      order: {},
      cancelDialog: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
     winStepper(item) {
      console.log("winstepperItem =",item)
      if (item.ref == "addrating") {
        this.addRating(item);
      }
      if (item.type == "cancell") this.cancelOrder(item);
    },
     addRating(item) {
      console.log("item=",item)
      this.appLoading = true;
      axios({
        method: "post",
        url: "Review/Add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
         orderitemId: item.orderitemId,
          productid: item.productid,
          rating: item.rating,
          comment: item.comment,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackBarColor = "#3EA56E";
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.snackBarColor = "#FF1313";
            this.showSnackBar = true;
          }
          this.getData();

          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/customer/order/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.order = response.data.data;
            this.product = response.data.items;
            // this.orders = response.data.data.details;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.snackBarColor = "#FF1313";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
   
    // winStepper(item) {
    //   if (item.type == "cancell") this.cancelOrder(item);
    // },
    cancelOrder(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/customer/order/cancel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          // id: item.transactionid,
          itemId: item.id,
          orderId :item.orderId
          // status: "Cancelled",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = response.data.msg;
            this.snackBarColor = "#3EA56E";
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.snackBarColor = "#FF1313";
            this.showSnackBar = true;
          }
          this.getData();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
   console.log("cncel=",item)
   },
    // cancelDeal() {
    //   this.appLoading = true;
    //   axios({
    //     method: "POST",
    //     url: "/purchase/canceldeal",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     data: {
    //       id: this.order._id,
    //       status: "Cancelled",
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       this.cancelDialog = false;
    //       if (response.data.status) {
    //         this.getData();
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    formatDate(item) {
      if (!item) return "";
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
  },
};
</script>

<style scoped>
.page-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 24px;
  color: #1e293b;
  margin: 0;
}

.id-chip {
  font-family: "poppinsmedium", sans-serif;
  letter-spacing: 0.5px;
}

.summary-banner {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px !important;
  border: 1px solid #e2e8f0;
}

.banner-label {
  font-family: "poppinsmedium", sans-serif;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.banner-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 18px;
  color: #1e293b;
}

.section-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.order-item-card {
  border: 1px solid #f1f5f9;
  border-radius: 12px !important;
  padding: 16px;
}

.sidebar-card {
  border: 1px solid #f1f5f9;
  border-radius: 16px !important;
  background: #ffffff;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }
  .banner-value {
    font-size: 16px;
  }
}
</style>